import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Properties = _resolveComponent("Properties")!

  return (_ctx.location)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Properties, {
          subModel: _ctx.subModel,
          model: _ctx.model,
          location: _ctx.location,
          locationProperties: _ctx.locationProperties != null ? _ctx.locationProperties.filter(_ctx.selectViewLocation) : null,
          propertyIcons: _ctx.propertyIcons,
          showIconMenu: true
        }, null, 8, ["subModel", "model", "location", "locationProperties", "propertyIcons"])
      ]))
    : _createCommentVNode("", true)
}